<template>
  <div class="card">
    <div class="card-body">
      <h4 class="card-title mb-4">Comments</h4>

      <div class="media mb-4">
        <div class="me-3">
          <img
              class="media-object rounded-circle avatar-xs"
              alt
              src="@/assets/images/users/avatar-2.jpg"
          />
        </div>
        <div class="media-body">
          <h5 class="font-size-13 mb-1">David Lambert</h5>
          <p class="text-muted mb-1">Separate existence is a myth.</p>
        </div>
        <div class="ms-3">
          <a href class="text-primary">Reply</a>
        </div>
      </div>

      <div class="media mb-4">
        <div class="me-3">
          <img
              class="media-object rounded-circle avatar-xs"
              alt
              src="@/assets/images/users/avatar-3.jpg"
          />
        </div>
        <div class="media-body">
          <h5 class="font-size-13 mb-1">Steve Foster</h5>
          <p class="text-muted mb-1">
            <a href class="text-success">@Henry</a>
            To an English person it will like simplified
          </p>
          <div class="media mt-3">
            <div class="avatar-xs me-3">
                    <span
                        class="avatar-title rounded-circle bg-soft bg-primary text-primary font-size-16"
                    >J</span>
            </div>
            <div class="media-body">
              <h5 class="font-size-13 mb-1">Jeffrey Walker</h5>
              <p class="text-muted mb-1">as a skeptical Cambridge friend</p>
            </div>
            <div class="ms-3">
              <a href class="text-primary">Reply</a>
            </div>
          </div>
        </div>
        <div class="ms-3">
          <a href class="text-primary">Reply</a>
        </div>
      </div>

      <div class="media mb-4">
        <div class="avatar-xs me-3">
                <span
                    class="avatar-title rounded-circle bg-soft bg-primary text-primary font-size-16"
                >S</span>
        </div>
        <div class="media-body">
          <h5 class="font-size-13 mb-1">Steven Carlson</h5>
          <p class="text-muted mb-1">Separate existence is a myth.</p>
        </div>
        <div class="ms-3">
          <a href class="text-primary">Reply</a>
        </div>
      </div>

      <div class="text-center mt-4 pt-2">
        <a href="javascript: void(0);" class="btn btn-primary btn-sm">View more</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CommentsCard"
}
</script>

<style scoped>

</style>
